var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-point-collection',{attrs:{"points":_vm.mapItemList,"shape":_vm.shapeType,"color":_vm.colorType,"size":_vm.mapPointSizeType},on:{"click":_vm.collectionPoleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }